/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { ordersBotCallbackRequestSchema } from "./ordersBotCallbackRequestSchema.ts";

export const callbackTgCancelledOrderCreateStatus200Schema = z.any();

export const callbackTgCancelledOrderCreateResponseSchema = callbackTgCancelledOrderCreateStatus200Schema;

export const callbackTgCancelledOrderCreateDataSchemaJson = ordersBotCallbackRequestSchema;

export const callbackTgCancelledOrderCreateDataSchemaXml = ordersBotCallbackRequestSchema;

export const callbackTgCancelledOrderCreateDataSchema = z.union([callbackTgCancelledOrderCreateDataSchemaJson, callbackTgCancelledOrderCreateDataSchemaXml]);
